export default {
  "pages": "C:/Users/cathe/Downloads/Web Dev/Test/anabel-routify-private/src/pages",
  "sourceDir": "src",
  "routifyDir": "node_modules/@sveltech/routify/tmp",
  "ignore": [],
  "unknownPropWarnings": true,
  "dynamicImports": false,
  "singleBuild": false,
  "scroll": "smooth",
  "extensions": [
    "html",
    "svelte",
    "md"
  ],
  "distDir": "dist",
  "noPrerender": false,
  "ssr": true,
  "prerender": true,
  "staticDir": "static",
  "scriptsDir": "scripts",
  "childProcess": "rollup -c -w",
  "unusedPropWarnings": true
}